export const VIEWER_SESSION_FAILURE = {
  title: "We couldn't start the viewer",
  detail: "",
};

export const VIEWER_BUILD_FAILURE = {
  title: "The 3D viewer is unavailable",
  detail: "",
};

export const VIEWER_STARTUP_FAILURE = {
  title: "The 3D viewer couldn't start",
  summary: "The viewer is unavailable on this device.",
  detail: "",
};

export const WEBGPU_UNAVAILABLE = {
  title: "This device can't run the 3D viewer",
  summary: "The required graphics features aren't available on this device.",
  detail: "",
};

export const getDashboardSessionMessage = (error) => {
  if (error?.code === "ACCESS_DENIED") {
    return "This account doesn't have access to this experience.";
  }

  if (error?.code === "AUTH_REQUIRED") {
    return "Your dashboard session has ended. Return to the dashboard and open this experience again.";
  }

  return "The viewer couldn't verify your dashboard session.";
};

export const getJoinFailureMessage = (error) => {
  const status = error?.response?.status;
  if (status === 400 || status === 404) {
    return "That join code wasn't recognized. Check the code and try again.";
  }
  if (status === 401 || status === 403 || status === 410) {
    return "That join code is no longer active. Ask your teacher for a new one.";
  }
  if (status === 429) {
    return "Too many attempts were made. Wait a moment and try again.";
  }
  if (!error?.response && error?.request) {
    return "We couldn't reach the viewer. Check your connection and try again.";
  }
  return "This experience can't be joined right now.";
};

export const getExperienceLoadMessage = (mode, error) => {
  const status = error?.response?.status;

  if (status === 404) {
    return "This experience is no longer available.";
  }

  if (status === 401 || status === 403) {
    if (mode === "teacher") {
      return "Your dashboard session has ended. Return to the dashboard and open this experience again.";
    }
    if (mode === "viewer") {
      return "This viewing session has ended. Open your join link again.";
    }
    return "This viewer session has ended. Reload the page to start a new session.";
  }

  if (!error?.response && error?.request) {
    return "We couldn't reach the viewer. Check your connection and reload the page.";
  }

  return "This experience is unavailable right now.";
};
